// Converts <h2>Label:</h2> section headers within the product description
// into smoothly-animated click-to-expand accordion rows, reusing the theme's
// existing `.details` / `.details__header` accordion classes and its
// `.icon-animated` arrow-rotation CSS (see snippets/summary-icon-styles.liquid)
// so the arrow flip stays consistent with the rest of the theme.
document.addEventListener('DOMContentLoaded', function () {
  var containers = document.querySelectorAll('[class*="text_aEtTtq"], .species-profile-content');

  containers.forEach(function (container) {
    var headings = Array.prototype.slice.call(container.querySelectorAll('h2, h3'));
    var firstElementChild = container.firstElementChild;

    headings.forEach(function (heading) {
      // When a product's description opens directly with its title as a
      // heading (no separate intro paragraph before it), leave that first
      // heading and its intro content plain and always visible instead of
      // collapsing it, matching the products whose intro text naturally
      // precedes the first heading.
      if (heading === firstElementChild) return;

      var parent = heading.parentNode;
      if (!parent) return;

      var contentNodes = [];
      var node = heading.nextSibling;

      while (node && !(node.nodeType === 1 && (node.tagName === 'H2' || node.tagName === 'H3'))) {
        var next = node.nextSibling;
        contentNodes.push(node);
        node = next;
      }

      // Nothing follows this heading — leave it as a plain heading rather than
      // creating an empty, non-functional accordion row.
      if (contentNodes.length === 0) return;

      var details = document.createElement('details');
      details.className = 'details product-description-accordion';

      var summary = document.createElement('summary');
      summary.className = 'details__header';
      summary.innerHTML = heading.innerHTML;

      var chevronWrapper = document.createElement('span');
      chevronWrapper.className = 'svg-wrapper icon-caret icon-animated';
      chevronWrapper.innerHTML =
        '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M11 5.5L7 9.5L3 5.5" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>';
      summary.appendChild(chevronWrapper);

      var contentOuter = document.createElement('div');
      contentOuter.className = 'details-content';

      var contentInner = document.createElement('div');
      contentInner.className = 'details-content__inner';
      contentNodes.forEach(function (n) {
        contentInner.appendChild(n);
      });
      contentOuter.appendChild(contentInner);

      details.appendChild(summary);
      details.appendChild(contentOuter);

      parent.replaceChild(details, heading);

      setupAnimatedToggle(details, summary, contentOuter);
    });
  });

  function setupAnimatedToggle(details, summary, contentOuter) {
    summary.addEventListener('click', function (event) {
      event.preventDefault();

      if (details.open) {
        // Closing: animate the row track down to 0fr, then drop the native
        // `open` attribute once the transition finishes so it matches the
        // now-collapsed visual state instead of snapping shut instantly.
        contentOuter.style.gridTemplateRows = '0fr';

        var onCloseEnd = function (e) {
          if (e.target !== contentOuter) return;
          details.removeAttribute('open');
          contentOuter.removeEventListener('transitionend', onCloseEnd);
        };
        contentOuter.addEventListener('transitionend', onCloseEnd);
      } else {
        // Opening: add `open` first so the content is rendered/measurable,
        // start the row track at 0fr, then animate to 1fr on the next paint
        // so the transition actually plays instead of jumping straight open.
        details.setAttribute('open', '');
        contentOuter.style.gridTemplateRows = '0fr';

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            contentOuter.style.gridTemplateRows = '1fr';
          });
        });
      }
    });
  }
});
